import { Button, Size } from "@leafygreen-ui/button";
import { TaskStatus } from "@evg-ui/lib/types/task";
import { getLocalStorageBoolean } from "@evg-ui/lib/utils/localStorage";
import { useTaskReview } from "components/TaskReview/useTaskReview";
import { DISABLE_TASK_REVIEW } from "constants/cookies";

export const MarkReviewed: React.FC<{
  taskId: string;
  execution: number;
}> = ({ execution, taskId }) => {
  const { checked, task, updateDisplayTask, updateTask } = useTaskReview({
    taskId: taskId ?? "",
    execution: execution ?? 0,
  });

  const handleClick = () => {
    if (task?.executionTasksFull?.length) {
      updateDisplayTask();
    } else {
      updateTask();
    }
  };

  const taskReviewEnabled = !getLocalStorageBoolean(DISABLE_TASK_REVIEW, false);

  return taskReviewEnabled ? (
    <Button
      disabled={task.displayStatus === TaskStatus.Succeeded}
      onClick={handleClick}
      size={Size.Small}
    >
      {checked ? "Mark unreviewed" : "Mark reviewed"}
    </Button>
  ) : null;
};
